<template>
    <tr>
      <td class="mobile-header" data-th="Fornecedor">{{ nota.nomeFornecedor }}</td>
      <td class="mobile-header" data-th="Serviço">{{ nota.servico }}</td>
      <td class="mobile-header" data-th="Valor" align="center">{{ nota.valor | number_format }}</td>
      <td class="mobile-header" data-th="Vencimento" align="center">{{ nota.dataVencimento | date("dd/LL/yyyy") }}</td>
      <td class="mobile-header" data-th="Nota Fiscal" align="center">
        <download-link :href="url_download" target="_system"  class="default-button">
          <i class="mdi mdi-download mdi-18px"></i>
        </download-link>
      </td>
      <td class="mobile-header buttons" data-th="Autorização" align="center" width="150">
        <button class="default-button" @click="autorizar">SIM</button>
        <button class="default-button red" @click="naoAutoriza">NÃO</button>
        <PopupNotas v-if="show_popup_notas" @close="hidePopUpNotas" @success="$emit('success')" :nota="nota"></PopupNotas>
      </td>
    </tr>
  </template>
  
<script>
import Swal from 'sweetalert2';
import api from '/plugins/api';
import PopupNotas from './popup-notas.vue';
import { api_endpoint } from '~/plugins/api';
export default {
    props: ["nota"],
    filters: {
        number_format(value) {
            return new Intl.NumberFormat("pt-br", {
                style: "currency",
                currency: "BRL",
            }).format(value);
        },
    },
    components: {
        PopupNotas
    },
    data() {
        return {
            show_popup_notas: false
        }
    },
    computed: {
        condominio() {
            return this.$store.getters.condominio;
        },
        codigo_condominio() {
            if (!this.condominio) {
                return null;
            }
            return this.condominio.codigo;
        },
        jwt() {
            return this.$store.state.jwt;
        },
        url_download() {
            //let endpoint = `${location.origin}${location.pathname}api`;
            let endpoint = api_endpoint
            if (location.origin =='file://' || 'undefined' != typeof window.cordova) {                
                endpoint = window.api_endpoint;
            }
            return `${endpoint}/condominios/${this.codigo_condominio}/autorizacao-notas/${this.nota.idDocsprime}/download?jwt=${this.jwt}`;
        },
    },
    methods: {
        async naoAutoriza() {
            try {
                let { value: motivo} = await Swal.fire({
                    title: "Qual o motivo da não autorização?",
                    input: 'text',
                    inputLabel: "Motivo",
                    showCancelButton: true,
                    inputValidator(value) {
                        if (!value) {
                            return "Você precisa informar o motivo.";
                        }
                    }
                });
                if (!motivo) {
                    return;
                }
                let formData = {
                    ...this.nota,
                    motivo,
                    autorizado: 'N'
                };
                let { data: { success, mensagem = 'Autorização alterada com sucesso!' } } = await api.post(`condominios/${this.codigo_condominio}/autorizacao-notas/processar`, formData);
                if (!success) {
                    throw new Error("Não foi possível alterar a autorização.");
                }
                Swal.fire({
                    icon: 'success',
                    title: "Sucesso!",
                    text: mensagem
                });
                this.$emit('success');
            } catch (err) {
                this.errors = [];
                let text =
                    err.message ||
                    "Não foi possível enviar sua resposta.";

                if (err.response && err.response.data) {
                    text = err.response.data.error;
                }
                Swal.fire({
                    icon: "error",
                    title: "Oops",
                    text,
                });
                console.error(err);
                this.errors = [...this.errors, err];
            }
        },
        showPopUpNotas() {
            this.show_popup_notas = true;
        },
        hidePopUpNotas() {
            this.show_popup_notas = false;
        },
        async autorizar() {
            try {
                let { isConfirmed } = await Swal.fire({
                    title: 'Deseja realmente autorizar?',
                    showCancelButton: true,
                    cancelButtonText: "Não",
                    confirmButtonText: "Sim"
                });

                if (!isConfirmed) {
                    return;
                }

                this.showPopUpNotas();
                
            } catch (err) {
                this.errors = [];
                let text =
                    err.message ||
                    "Não foi possível enviar sua resposta.";

                if (err.response && err.response.data) {
                    text = err.response.data.error;
                }
                Swal.fire({
                    icon: "error",
                    title: "Oops",
                    text,
                });
                console.error(err);
                this.errors = [...this.errors, err];
            }
        }
    }
};
</script>